<template>
  <body class="main-body">
    <div class="body-container" style="overflow: scroll;">
      <div class="not-applied-msg" v-if="contentsApply.length == 0 && re_company_list.length == 0">
        <p>現在、応募済みの求人、会話済みのロボはございません。</p>
      </div>
      <div class="work-content" v-else>
        <div class="grid-container" :class="{chat_true: chatWindow}">
          <div class="listcompany">
            <ul>
              <li
                v-for="(c, index) in re_company_list"
                :key = index
                class="card-company"
                v-bind:class="{'card-this-company' : companyid == c.company_hash}"
                @click="clickLogLink(c.company_hash)"
              >
                <div>
                  <div class="company-info-container">
                    <div class="company-info">
                      <div class="img-icon-75px">
                        <img :src="c.company_logo" v-if="c.company_logo!=''">
                        <p v-if="c.company_logo==''">{{c.company_name[0]}}</p>
                      </div>
                      <div class="company-info__str">
                        <p class="last-day">    
                          {{getLastDay(c.company_hash)}} 
                        </p>
                        <div class="new-message" v-if="getSort(c.company_hash) > getLastRead(c.company_hash)"> 
                          <p>New!</p>
                        </div>
                        <p class="company-name">
                          {{c.company_name}}
                        </p>
                        <p class="last-message" v-if="getLastMessage(c.company_hash) != ''">
                          {{convertMesasge(getLastMessage(c.company_hash))}}
                        </p>
                        <p class="last-message" v-else>
                          <!-- ロボとの会話はございません。 -->
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="infocompany" :class="{'-none': !chatWindow}">
            <i class="arrow-left mdi mdi-arrow-left mdi-36px" @click="clickBack"></i>
            <div class="info-company-name">
              {{getCompanyName(companyid)}}
            </div>
          </div>
          <div class="chat-dialog">
            <template v-if="chatLogs.length > 0">
              <Balloon
                v-for="(chat,index) in chatLogs" :key="index"
                :speaker="chat.speaker"
                :name="chat.name"
                :icon="chat.icon"
                :message="chat.message"
                :time="displayDate(chat)"
                :readTime="new Date(widgetData.readTime)"
                :isBot="chat.isBot"
                :email="chat.email"
                :isManager="chat.isManager"
                :logIndex="index"
                :lastIndex="chatLogs.length - 1"
                :files="chat.files"
                :filename="chat.filename"
                :status="chat.status"
                :parameter="chat.parameter"
                :companyData="widgetData"
                :roboPartsSetOutsideScenario="roboPartsSetOutsideScenario"
                :roboPartsSetNextNode="roboPartsSetNextNode"
              >
              </Balloon>
              <MogoMogo v-if="isTyping||isSCNLoading"/>
              <div style="height: 42px; width: 200px;" v-else></div>
            </template>
            <template v-else>
              <div>
                <p class="talk-nothing-msg">{{returnMsg()}}</p>
              </div>
            </template>
          </div>
        </div> 
      </div>
    </div>
  </body>
</template>



<script>
import Balloon from '@/components/ui/Balloon'
import MogoMogo from '@/components/ui/MogoMogo'
import Loading from '@/components/animations/Loading'
import { mapState } from 'vuex'
import _ from 'lodash'
export default {
  name: 'ChatSinglePage',
  componentName: 'ChatSinglePage',
  components: {
    Loading,
    Balloon,
    MogoMogo
  },
  data () {
    return {
      isDemo: false,
      file: null,
      isMessage: false,
      isTyping: '',
      isTypingScroll: false,
      isMobileInput: false,
      height: 45,
      flex: 0.5,
      num: null,
      companyid: null,
      botid: null,
      userData: {
        url: null,
        appname: null,
        platform: null,
        width: null,
        height: null,
        color: null,
        referrer: null,
        useragent: null,
        ckey: null,
        cookies: null,
        sessionid: null,
        count: null
      },
      chatbot: null,
      isSlideLeft: false,
      isSlideRight: false,
      isRead: false,
      testjudge: false,
      chatWindow: false
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState('employmentPage', ['companyList', 'contentsPublic', 'isContentsLoading', 'contentsCompany', 'contentsTops', 'contentsApply']),
    ...mapState('directtalk', ['chatLogs', 'chatLogs2', 'readLogs', 'seeker', 'data', 'chatData', 'widgetData', 'typing', 'mobileKey', 'color', 'power', 'own', 'messagePages', 'isChatLogs', 'selectroom']),
    ...mapState('chatbot', ['scenarioTable', 'isSwitch', 'scenario', 'isSCNLoading', 'isRoboPartsSetInside', 'roboPartsSetOutsideScenario', 'roboPartsSetNextNode']),
    ...mapState('calendar', ['schedule', 'recommendDate']),
    re_company_list () {
      return this.companyList.sort((a, b) => {
          return (this.getSort(a.company_hash) < this.getSort(b.company_hash)) ? 1 : (this.getSort(a.company_hash) > this.getSort(b.company_hash)) ? -1 : 0;
      })
    }
  },
  mounted () {
    this.$emit('statusMethod', this.testjudge)
    console.debug('Start mounted')
    // 訪問者情報の割当
    this.userData.url = location.href
    this.userData.appname = window.navigator.appName
    this.userData.platform = window.navigator.platform
    this.userData.width = window.screen.width
    this.userData.height = window.screen.height
    this.userData.color = window.screen.colorDepth
    this.userData.referrer = document.referrer
    this.userData.useragent = window.navigator.userAgent
    this.userData.ckey = this.$route.params.companyid
    this.userData.cookies = document.cookie
    this.userData.sessionid = localStorage.getItem('SID_' + this.$route.params.companyid)
    this.userData.count = localStorage.getItem('CNT_' + this.$route.params.botid)
    this.companyid = this.$route.params.companyid
    this.botid = this.$route.params.botid
    this.$store.dispatch('directtalk/setJson', this.userData)
    var vm = this
    document.addEventListener('DOMFocusIn', function (event) {
      // キーボードが出現した時
      console.log('***** DOMFOCUSIN Height:')
      vm.$store.dispatch('directtalk/mobileType')
    }, false)
    document.addEventListener('DOMFocusOut', function (event) {
      // キーボードが引っ込んだ時
      console.log('***** DOMFOCUSOUT Height: ')
      vm.$store.dispatch('directtalk/mobileType')
    }, false)
    document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
    window.addEventListener('resize', () => {
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    })
    console.debug('End mounted')
  },
  watch: {
    'seeker.id' () {
      console.debug('Start seeker.id')
      var uri = process.env.WS_ENDPOINT + this.data.ckey + '/' + this.seeker.id + '/'
      localStorage.setItem('SID_' + this.$route.params.companyid, this.seeker.id)
      localStorage.setItem('CNT_' + this.$route.params.botid, this.seeker.count)
      this.$store.dispatch('directtalk/getMessage', {name: 'seeker', pages: this.messagePages})
      // this.$store.dispatch('directtalk/getLastMessage', {data:this.user.profileSeeker_info, name: 'seeker', pages: this.messagePages})
      // this.$store.dispatch('directtalk/getReadLastMessage', {data:this.user.profileSeeker_info, name: 'seeker', pages: this.messagePages})
      this.$store.dispatch('directtalk/connect', {uri: uri, category: 'widget'})
      this.$store.dispatch('directtalk/getRoom')
      console.debug('End seeker.id')
    },
    async 'widgetData.name' () {
      console.debug('Start widgetData.name')
      let bot_info = await this.$store.dispatch('directtalk/getRoboInfo', {'robo_id': this.botid})
      if (bot_info) {
        this.$store.dispatch('auth/slackPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: ''})
        this.$store.dispatch('auth/CWPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: ''})
        this.chatbot = bot_info
      }
      console.debug('End widgetData.name')
    },
    typing () {
      console.debug('Start typing')
      if (this.typing.indexOf('start_typing:') !== -1) {
        console.debug('start_typing')
        this.isTyping = '入力中...'
        if (!this.isTypingScroll) {
          console.debug('not isTypingScroll')
          this.isTypingScroll = true
          this.$nextTick(() => {this.scrollDown()})
        }
      } else if (this.typing.indexOf('end_typing:') !== -1) {
        console.debug('not start_typing')
        this.isTyping = ''
        this.isTypingScroll = false
      }
      console.debug('End typing')
    },
    isSCNLoading () {
      console.debug('Start isSCNLoading')
      if (this.isSCNLoading) {
        console.info('isSCNLoading')
        this.isTypingScroll = true
        this.$nextTick(() => {this.scrollDown()})
      } else {
        console.info('not isSCNLoading')
        this.isTypingScroll = false
      }
      console.debug('End isSCNLoading')
    },
    recommendDate () {
      console.debug('Start recommendDate')
      this.pushScenarioCalendar()
      console.debug('End recommendDate')
    },
    scenario () {
      console.debug('Start scenario')
      console.log("CHECK SCENARIO STATUS", this.scenario.status)
      let scenarioName = null
      let nextNode = null
      if (this.scenario.output_flg === true) {
        scenarioName = this.roboPartsSetOutsideScenario
        nextNode = this.roboPartsSetNextNode
      } else {
        scenarioName = this.scenario.name
        nextNode = this.scenario.select[0].next_node
      }
      // 続けざまのメッセージの場合
      if (this.scenario.status === 2 || this.scenario.status === 5) {
        console.info('scenario.status is 2 or 5')
        this.$store.dispatch('chatbot/getScenarioOne', { companyid: this.data.ckey, scenarioName: scenarioName, node: nextNode, rate: this.color.thinking_rate})
        this.pushScenario()
      } else if (this.scenario.status === 3) {
        console.info('scenario.status is 3')
        this.$store.dispatch('directtalk/createSeekerATHistory', {target: this.scenario.mainmessage, action: 'select_bot', url: this.data.url, element: nextNode})
        // ロボ切り替えの場合は、next_nodeに次のロボのIDが入っている
        this.$store.dispatch('chatbot/getScenarioOne', { companyid: this.data.ckey, scenarioName: nextNode, node: 'INITIALIZE', rate: this.color.thinking_rate})
      } else if (this.scenario.status === 4) {
        console.info('scenario.status is 4')
        this.getCalendar()
      } else if (this.scenario.status === 9) {
        console.info('scenario.status is 9')
        this.$store.dispatch('chatbot/getScenarioOne', { companyid: this.data.ckey, scenarioName: scenarioName, node: 'INITIALIZE' })
      } else if (this.scenario.status === 10) {
        this.$store.dispatch('chatbot/sendEmailScenario', { companyid: this.data.ckey, content: this.scenario, sessionid: this.seeker.id, point: localStorage.getItem('SCR'), is_demo: false})
        this.$store.dispatch('chatbot/getScenarioOne', { companyid: this.data.ckey, scenarioName: scenarioName, node: nextNode })
      } else {
        console.info('scenario.status is other')
        this.pushScenario()
      }
      this.$store.dispatch('directtalk/setIsRead', 'seeker')
      console.debug('End scenario')
    },
    'chatData.message': function () {
      console.debug('Start chatData.message')
      if (this.chatData.message !== '') {
        console.info('chatData.message not blank')
        this.$store.dispatch('directtalk/isTyping', 'start_typing@seeker')
        this.num = this.chatData.message.match(/\r\n|\n/g)
        if (this.num != null) {
          console.info('num is not null')
          this.flex = 1.30
          this.height = 90
        } else {
          console.info('else')
          this.flex = 0.5
          this.height = 45
        }
      } else {
        console.info('else')
        this.$store.dispatch('directtalk/isTyping', 'end_typing@seeker')
        this.num = this.chatData.message.match(/\r\n|\n/g)
        if (this.num != null) {
          console.info('num is not null')
          this.flex = 1.30
          this.height = 90
        } else {
          console.info('num is null')
          this.flex = 0.5
          this.height = 45
        }
      }
      console.debug('End chatData.message')
    },
    chatLogs () {
      console.debug('Start chatLogs')
      setTimeout(() => {
        console.debug('Start setTimeout (chatLogs)')
        this.scrollDown()
        console.debug('End setTimeout (chatLogs)')
        }, 300)
      console.debug('Start chatLogs')
    },
    chatbot () {
      console.debug('Start chatbot')
      // 各種アクションの履歴テーブル登録
      this.$store.dispatch('directtalk/createSeekerATHistory', {target: this.chatbot.name, action: 'click_room_link', url: this.data.url, element: 'button'})
      this.$store.dispatch('directtalk/setDT', {name: this.chatbot.display_name, icon: this.chatbot.icon_data, id: this.chatbot.bot_id, model: 'bot'})
      this.$store.dispatch('chatbot/setMiniPK', this.chatbot.pk || null)
      this.$store.dispatch('chatbot/getScenarioOne', { companyid: this.data.ckey, scenarioName: this.chatbot.scenario_name, node: 'INITIALIZE', rate: this.color.thinking_rate})
      console.debug('End chatbot')
    },
    '$route.params.companyid' () {
      this.companyid = this.$route.params.companyid
    }
  },
  methods: {
    convertMesasge (m) {
      if (m.indexOf("[msg]") > -1) {
        var firstText = m.split("|");
        var text = firstText[0].replace("[msg]", "").replace("[/msg]", "");
        return text.split(",")[0];
      }
    },
    getCalendar () {
      console.debug('Start getCalendar')
      let param = _.cloneDeep(this.scenario.parameter)
      // 開始日を計算
      let now = new Date()
      now = new Date(now.setSeconds(0))
      now = new Date(now.setHours(param.work_time_start))
      now = new Date(now.setMinutes((param.work_time_start * 100) - (now.getHours() * 100)))
      let nextDay = new Date(now.setDate(new Date().getDate() + param.after))
      param.after = nextDay.toLocaleString('ja-JP')
      this.$store.dispatch('calendar/getRecommendSchedule', param)
      console.debug('End getCalendar')
    },
    pushScenario () {
      console.debug('Start pushScenario')
      var scenarioData = this.makeScenario()
      this.$store.dispatch('directtalk/pushChat', scenarioData)
      this.$store.dispatch('directtalk/createSeekerATHistory', {target: scenarioData.email, action: 'send_scn', url: this.data.url, element: this.scenario.beforenode})
      console.debug('End pushScenario')
    },
    pushScenarioCalendar () {
      console.debug('Start pushScenarioCalendar')
      var scenarioData = this.makeScenarioCalendar()
      this.$store.dispatch('directtalk/pushChat', scenarioData)
      this.$store.dispatch('directtalk/createSeekerATHistory', {target: scenarioData.email, action: 'send_scn', url: this.data.url, element: this.scenario.beforenode})
      console.debug('End pushScenarioCalendar')
    },
    makeScenarioCalendar () {
      console.debug('Start makeScenarioCalendar')
      var name = ''
      var id = ''
      var icon = ''
      // ロボを切り替える場合はシナリオ読み込み一回以上している状態
      if (this.isSwitch > 0) {
        console.info('isSwitch > 0')
      } else {
        console.info('isSwitch <= 0')
        name = this.chatbot.name
        id = this.chatbot.bot_id
        icon = this.chatbot.icon_data
      }
      var templateDate = ''
      if (this.recommendDate.start !== 'Initialized') {
        const buttonTagS = '[button]'
        const buttonTagE = '[/button]'
        const pipe = '|'
        for (let i=0; i<this.recommendDate.length; i++) {
          const recDate =
            new Date(this.recommendDate[i].start).getMonth() + 1 + '/' + new Date(this.recommendDate[i].start).getDate() + ' ' +
            new Date(this.recommendDate[i].start).getHours() +     ':' + ('00' + new Date(this.recommendDate[i].start).getMinutes()).slice(-2) + ' ~ ' +
            Number(new Date(this.recommendDate[i].end).getMonth() + 1) + '/' + new Date(this.recommendDate[i].end).getDate() + ' ' +
            new Date(this.recommendDate[i].end).getHours()   +     ':' + ('00' + new Date(this.recommendDate[i].end).getMinutes()).slice(-2)
          templateDate += pipe + buttonTagS + recDate + buttonTagE
        }
      }
      var scenarioData = {
        message: '[msg]' + this.scenario.mainmessage + '[/msg]' + templateDate,
        name: name,
        url: this.data.url,
        email: id,
        speaker: 'other',
        icon: icon,
        createdAt: new Date().toISOString(),
        sendToID: '',
        minibot_pk: '',
        sendToModel: '',
        isManager: '2',
        appname: '',
        platform: '',
        refferer: '',
        useragent: '',
        count: 0,
        status: this.scenario.status,
        parameter: this.scenario.parameter,
      }
      console.debug('End makeScenarioCalendar: ' + scenarioData)
      return scenarioData
    },
    handleVisibilityChange () {
      console.debug('Start handleVisibilityChange')
      if (document.hidden) {
        console.info('document.hidden is true')
        this.$store.dispatch('directtalk/disconnect')
      } else {
        console.info('document.hidden is false')
        var uri = process.env.WS_ENDPOINT + this.data.ckey + '/' + this.seeker.id + '/'
        if (this.seeker.id != null) {
          console.info('seeker.id is not null')
          this.$store.dispatch('directtalk/connect', {uri: uri, category: 'widget'})
            .then(() => { this.$store.dispatch('directtalk/getMessage', {name: 'seeker', pages: this.messagePages})
                          this.$store.dispatch('directtalk/getLastMessage', {name: 'seeker', pages: this.messagePages})
        })}
      }
      console.debug('End handleVisibilityChange')
    },
    submit () {
      console.debug('Start submit')
      console.log('submit from widget \n' + this.data)
      var w = this.data
      console.log('FROM URL: \n' + w.appname)
      this.chatData.name = this.widgetData.name
      this.chatData.url = w.url
      console.log('Widget: ' + this.chatData.name)
      if (this.chatData.message !== '') {
        console.info('chatData.message is not blank')
        this.chatData.email = ''
        var today = new Date()
        console.log('now: ' + today.toISOString())
        this.chatData.createdAt = today.toISOString()
        this.chatData.isManager = '0'
        this.chatData.sendToModel = 'bot'
        var promise = Promise.resolve()
        promise
          .then(this.$store.dispatch('auth/slackPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: this.chatData.message}))
          .then(this.$store.dispatch('auth/CWPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: this.chatData.message}))
          .then(this.$store.dispatch('directtalk/pushChat', this.chatData))
          .then(this.chatData.message = '')
      }
      console.debug('End submit')
    },
    scrollDown () {
      console.debug('Start scrollDown')
      var target = document.querySelector('.chat-dialog')
      if (!target) return
      target.scrollTop = target.scrollHeight
      console.log('scrollDown methods: ' + target.scrollTop + '\n' + target.scrollHeight)
      console.debug('End scrollDown')
    },
    substr (m, l) {
      console.debug('Start substr')
      console.debug('m: ' + m)
      console.debug('l: ' + l)
      return m.length > l ? m.substring(0, l - 3) + '...' : m
    },
    getCompanyName (id) {
      console.debug('Start getCompanyName')
      console.debug('id: ' + id)
      for (var i in this.contentsCompany) {
        if (this.contentsCompany[i].company_hash == id) return this.substr(this.contentsCompany[i].company_name, 50)
      }
      console.debug('End getCompanyName')
      return ''
    },
    getCompanyLogo (id) {
      console.debug('Start getCompanyLogo')
      this.isMessage = true
      console.debug('id: ' + id)
      for (var i in this.contentsCompany) {
        if (this.contentsCompany[i].company_hash == id) return this.contentsCompany[i].company_logo
      }
      console.debug('End getCompanyLogo')
      return ''
    },
    getLastMessage(id) {
      console.debug('Start getCompanyName')
      console.debug('id: ' + id)
      for (var i = this.chatLogs2.length - 1; i >= 0; i--) { 
        if (this.chatLogs2[i].testid == id) return this.substr(this.chatLogs2[i].message,32)
      }
      console.debug('End getCompanyName')
      return ''
    },
    getLastDay (id) {
      console.debug('Start getLastDay')
      console.debug('id: ' + id)
      for (var i = this.chatLogs2.length - 1; i >= 0; i--) { 
        if (this.chatLogs2[i].testid == id) return this.substr(this.chatLogs2[i].createB)
      }
      console.debug('End getLastDay')
      return ''
    },
    getSort (id) {
      console.debug('Start getSort')
      console.debug('id: ' + id)
      for (var i = this.chatLogs2.length - 1; i >= 0; i--) {
        if (this.chatLogs2[i].testid == id) return this.substr(this.chatLogs2[i].createC)
      }
      console.debug('End getSort')
      return ''
    },
    getLastName (id) {
      console.debug('Start getLastName')
      console.debug('id: ' + id)
      for (var i = this.chatLogs2.length - 1; i >= 0; i--) {
        if (this.chatLogs2[i].testid == id) return this.substr(this.chatLogs2[i].name)
      }
      console.debug('End getLastName')
      return ''
    },
    getLastRead (id) {
      console.debug('Start getLastRead')
      console.debug('id: ' + id)
      for (var i = this.readLogs.length - 1; i >= 0; i--) {
        if(this.readLogs[i].testid == id) return this.substr(this.readLogs[i].createC)
      }
      console.debug('End getLastRead')
      return ''
    },
    next () {
      console.debug('Start next')
      this.$store.dispatch('employmentPage/nextContentsTops')
      console.debug('End next')
    },
    prev () {
      console.debug('Start prev')
      this.$store.dispatch('employmentPage/prevContentsTops')
      console.debug('End prev')
    },
    clickLogLink (link) {
      this.$router.push('/recruits/status/' + link);
      this.$emit('statusMethod', this.testjudge)
      // 訪問者情報の割当
      this.userData.url = location.href
      this.userData.appname = window.navigator.appName
      this.userData.platform = window.navigator.platform
      this.userData.width = window.screen.width
      this.userData.height = window.screen.height
      this.userData.color = window.screen.colorDepth
      this.userData.referrer = document.referrer
      this.userData.useragent = window.navigator.userAgent
      this.userData.ckey = this.$route.params.companyid
      this.userData.cookies = document.cookie
      this.userData.sessionid = localStorage.getItem('SID_' + this.$route.params.companyid)
      this.userData.count = localStorage.getItem('CNT_' + this.$route.params.botid)
      this.$store.dispatch('directtalk/setJson', this.userData)
      //スマホ画面時に社名のリストとチャット画面をtoggleさせる
      this.chatWindow = true
    },
    clickBack () {
      this.chatWindow = false
    },
    returnMsg () {
      const path = location.pathname.split('/')
      if (path[3] == 'company') {
        return '企業を選択してください。'
      } else {
        return '会話はございません。'
      }
    },
    displayDate(chat) {
      if (!isNaN(chat.createdAt)) {
        return new Date(chat.createdAt)
      } else {
        return new Date(chat.createdAtOther)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
html, body {
  width: 100vw;
  /* height: 100vh; */
  height: 100%;
}
h1 {
  font-size: larger;
  font-weight: 600;
}
.main-body {
  background-color: #ced4d1;
}
.flex-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.main-container {
  display: flex;
  flex-direction: column;
  /* flex-grow: 1; */
  height: calc(100% - 50px);
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.loading-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.company-header{
  background: #f8f8f8;
  height: 50px;
  display: flex;
  justify-content: center;
  flex-direction: column-reverse;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.chat-dialog {
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  scroll-behavior: smooth;
  background-color: #fff;
}

.chat-dialog::-webkit-scrollbar {
  width: 10px;
}

.input-button {
  background: transparent;
  border: none;
  resize: none;
  outline:none;
}

.parent-form {
  grid-area: parent-form;
  width: 100%;
  background: #F8F8F8;
  border-top: solid thin #CCC;
  border: solid #000000;
}
.child-form {
  text-align: center;
  padding-bottom: 0px !important;
  min-height: 45px;
  background: #F8F8F8;
}
textarea {
  min-width: calc(100% - 40px);
  max-width: calc(100% - 40px);
  font-size: 18px;
  border: none;
  resize: none;
  outline:none;
  line-height: 25px;
  padding-top: 10px;
  padding-left: 8px;
}
.loading-form {
  height: 20px;
  background-color: transparent;
  font-size: 16px;
}
.loading span {
  display: inline-block;
  margin: 0 -.05em;
  margin-left: 10px;
  animation: loading .7s infinite;
}
.loading span:nth-child(2) {
  animation-delay: .1s;
}
.loading span:nth-child(3) {
  animation-delay: .2s;
}
.loading span:nth-child(4) {
  animation-delay: .3s;
}
.loading span:nth-child(5) {
  animation-delay: .4s;
}
.loading span:nth-child(6) {
  animation-delay: .5s;
}
.loading span:nth-child(7) {
  animation-delay: .6s;
}
@keyframes loading {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
.list {
  height: 80vh;
}
.chat-list-enter-active, .chat-list-leave-active {
  transition: all 1s;
}
.chat-list-enter, .chat-list-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.mogomogo-enter-active, .mogomogo-leave-active {
  transition: all 1s;
}
.mogomogo-enter, .mogomogo-leave-to {
  position: absolute;
  transform: scale(0);
}

.body-container {
  background: #ffffff;
}
.main-cards {
  margin-top: 20px;
  display: -webkit-inline-box;
  overflow: hidden;
  position: relative;
  height: 400px;
  width: 100%;
}
.main-cards > a {
  text-decoration: none;
}
#carousel-0 {
  position: absolute;
  top: 0;
  left: 20px;
  bottom:0;
  margin: auto;
  transition: 0.5s;
}
#carousel-1 {
  position: absolute;
  top:0;left:0;right:0;bottom:0;
  margin: auto;
}
#carousel-2 {
  position: absolute;
  top: 0;
  right: 20px;
  bottom:0;
  margin: auto;
}
#carousel-3 {
  position: absolute;
  top: 0;
  right: -30%;
  bottom:0;
  margin: auto;
}
#carousel-4 {
  position: absolute;
  top: 0;
  left: -30%;
  bottom:0;
  margin: auto;
}
.slide-group-enter-active, .slide-group-leave-active {
  transition: all 1s;
}
.slide-group-enter, .slide-group-leave-to {
  transform: translateX(100%);
}

.right-arrow {
  position: absolute;
  right: 10px;
  top: 40%;
  z-index: 1;
  width: 48px;
  height: 48px;
  font-size: 24px;
  font-weight: 700;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
}
.left-arrow {
  position: absolute;
  left: 10px;
  top: 40%;
  z-index: 1;
  width: 48px;
  height: 48px;
  font-size: 24px;
  font-weight: 700;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
}

.tag {
  padding: 5px 7.5px;
  border-radius: 10px;
  text-align: center;
  background: #525;
  color: white;
  font-size: smaller;
}

.tags-list {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  padding: 0px 0px 10px 0px;
}

.job-tag {
  height: 100%;
  padding: 5px 0px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.job-tag > p {
  border: solid 2px #ccc;
  color: #666;
  padding: 5px 15px;
  margin-right: 10px;
  font-size: small;
}

.card-company {
  background-color: white;
  height: 100px;
  border: solid thin #ccc;
  border-top: none;
  border-left: none;
  position: relative;
  display: flex;
  align-items: center;
}

.card-company:not(.card-this-company):hover {
  cursor:pointer;
  background-color: -moz-linear-gradient(left, rgba(215, 3, 112, 0.3), rgba(168, 31, 248, 0.3));
  background: -webkit-linear-gradient(left, rgba(215, 3, 112, 0.3), rgba(168, 31, 248, 0.3));
  background: linear-gradient(to right, rgba(215, 3, 112, 0.5), rgba(168, 31, 248, 0.5));
}

.card-company a {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}

.card-company a:link {
  color: black;
}
.card-company a:visited {
  color: black;
}
.card-company a:hover {
  color: black;
}
.card-company a:active {
  color: black;
}

.card-this-company {
  background: -moz-linear-gradient(left, #D70370, #A81FF8);
  background: -webkit-linear-gradient(left, #D70370, #A81FF8);
  background: linear-gradient(to right, #D70370, #A81FF8);
  position:relative;
  .company-info__str {
    p {
      color: #ffffff !important;
    }
  }
}

.card-this-company:hover {
    cursor:auto;
}

.card-this-company a {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}

ul {
  list-style: none;
}

.company-name {
  font-size: 14px;
  text-align: left;
  font-weight: bold;
  color: #C82E42;
  border-bottom: 1px solid #d8d8d8;
  margin-bottom: 4px;
  padding-bottom: 4px;
} 
.info-company-name {
  font-size: 12px;
  text-align: left;
  font-weight: bold;
  margin-left: 8px;
  color: #C82E42;
} 

.last-message {
  font-size: 10px;
}
.last-day {
  font-size: small;
  font-size: 10px;
}
.new-message {
  font-size: 10px;
  position: absolute;
  color:silver;
  top: 6px;
  left: 4px;
  padding: 2px 5px;
  color: #ffffff; 
  border-radius: 8px;
  animation: flash 1.5s linear infinite;
  background-color: #89EFF6;
  p {
    color: #ffffff !important;
  }
}
@keyframes flash {
  0%,100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

.img-icon-75px > img {
  display:    block;
  min-width:  75px;
  min-height: 75px;
  width:      75px;
  height:     75px;
  max-width:  75px;
  max-height: 75px;
  object-fit: cover;
  border-radius: 50%;
  border: solid thin #ccc;
  background: white;
  float:left;
  margin:10px;
  margin-top:20px; 
}
.img-icon-75px > p {
  display: flex;
  justify-content: center;
  align-items: center;
  width:  64px;
  height: 64px;
  object-fit: cover;
  border-radius: 50%;
  border: solid thin #ccc;
  background: white;
  color: black;
  font-size: 38px;
  display: none;
}

.img-icon-35px {
  margin-left: 8px;
}
.img-icon-35px > img {
  display:    block;
  min-width:  35px;
  min-height: 35px;
  width:      35px;
  height:     35px;
  max-width:  35px;
  max-height: 35px;
  object-fit: cover;
  border-radius: 50%;
  border: solid thin #ccc;
  background: white;
  color: black;
  float: left;
  margin-top:5px;
  margin-left:15px;
}
.img-icon-35px > p {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  min-width:  35px;
  min-height: 35px;
  width:      35px;
  height:     35px;
  max-width:  35px;
  max-height: 35px;
  object-fit: cover;
  border-radius: 50%;
  border: solid thin #ccc;
  background: white;
  color: black;
  float: left;
  font-size: 20px;
  display: none;
}
.tags-list2 {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  padding: 0px 0px 10px 10px;
}

.job-tag2 {
  height: 100%;
  padding: 5px 0px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.job-tag2 > p {
  border: solid 2px #ccc;
  background-color: white;
  color: #666;
  border-radius: 25px;
  padding: 5px 15px;
  margin-right: 10px;
  font-size: small;
}

.grid-container {
  margin-top: 40px;
  display: grid;
  grid-template-columns: 400px 640px;
  grid-template-rows: 48px calc(100vh - (80px + 40px + 48px)); //header + margin-top + .infocompanyのheight
  grid-template-areas: "listcompany infocompany" "listcompany chat-dialog";
}

.listcompany-header {
  grid-area: listcompany-header;
}
.listcompany {
  border: 1px solid #d8d8d8;
  border-right:none;
  overflow-y: scroll;
  grid-area: listcompany;
}
.listcompany::-webkit-scrollbar {
  width: 10px;
}

.infocompany { 
  grid-area: infocompany; 
  display: flex;
  align-items: center;
  background-color: white;
  border: 1px solid #d8d8d8;
}

.chat-dialog { 
  grid-area: chat-dialog; 
  background-color: #fff;
  border: 1px solid #d8d8d8;
  border-top:none;
}
.company-info-container {
  display: flex;
  align-items: center;
  height: 100%;
  margin-left: 8px;
}
.company-info {
  display: flex;
  &__str {
    text-align: left;
    margin-left: 16px;
    color: #ffffff;
    p {
      color: #4a4a4a;
    }
  }
}
.arrow-left {
  display: none;
}
.work-content {
  display: flex;
  justify-content: center;
}
.talk-nothing-msg {
  margin-top: 16px;
}
.not-applied-msg {
  margin-top: 24px;
  p {
    font-size: 18px;
  }
}
@media screen and (max-width: 1024px) {
  .grid-container {
      grid-template-columns: 400px 400px;
  }
}

@media screen and (max-width: 800px) {
  .grid-container {
    grid-template-columns: 100vw 0;
    grid-template-rows: 48px calc(100vh - (48px + 48px));
    margin-top: 0;
  }
  .chat_true {
    grid-template-columns: 0 100vw;
  }
  .arrow-left {
    display: block;
    margin-left: 8px;
  }
  .info-company-name {
    font-size: 12px;
  }
  .infocompany {
    &.-none {
      display: none;
    }
  }
}

.reflection {
    height      :100%;
    width       :100%;
    position    :absolute;
    top         :0;
    left        :0;
    background-color: #fff;
    opacity     :0;
    animation:         reflection 1s ease-in-out infinite;
    -webkit-animation: reflection 1s ease-in-out infinite;
    -moz-animation:    reflection 1s ease-in-out infinite;
    -ms-animation:     reflection 1s ease-in-out infinite;
    -o-animation:      reflection 1s ease-in-out infinite;
}

@keyframes reflection {
  0%   { opacity: 0; }
  50%  { opacity: 0.3; }
  100% { opacity: 0; }
}
@-webkit-keyframes reflection {
  0%   { opacity: 0; }
  50%  { opacity: 0.3; }
  100% { opacity: 0; }
}
@-moz-keyframes reflection {
  0%   { opacity: 0; }
  50%  { opacity: 0.3; }
  100% { opacity: 0; }
}
@-ms-keyframes reflection {
  0%   { opacity: 0; }
  50%  { opacity: 0.3; }
  100% { opacity: 0; }
}
@-o-keyframes reflection {
  0%   { opacity: 0; }
  50%  { opacity: 0.3; }
  100% { opacity: 0; }
}

</style>



// WEBPACK FOOTER //
// src/views/ChatSinglePage/ChatRecruitView.vue